const { populate } = require('@/functions/objects');
const {
    toNullableInt,
    toNullableString,
    toString,
} = require('@/functions/transform');

class OrderFulfillmentInstructions {
    constructor(data = {}) {
        /**
         * @type {FulfillmentMethodEnumValue}
         */
        this.fulfillmentMethod = undefined;

        /**
         * @type {number|null}
         */
        this.tablePlanTableID = null;

        /**
         * @type {string|null}
         */
        this.tableName = null;

        /**
         * @type {string|null}
         */
        this.collectionNumber = null;

        populate(this, data);
    }

    getHydrationMap() {
        return {
            fulfillmentMethod: toString,
            tablePlanTableID: toNullableInt,
            tableName: toNullableString,
            collectionNumber: toNullableString,
        };
    }
}

module.exports = OrderFulfillmentInstructions;
